<div class="form__block">
  <button
    class="button button_dark button_standard button_centered"
    type="submit"
  >
    Save information
  </button>
</div>
